import {
  BufferOverflow_DROP_LATEST_getInstance2lljjnmqeitb9 as BufferOverflow_DROP_LATEST_getInstance,
  BufferOverflow_SUSPEND_getInstance3j24qbb4wnzlq as BufferOverflow_SUSPEND_getInstance,
  BufferOverflow_DROP_OLDEST_getInstance3u1027cpcc1wz as BufferOverflow_DROP_OLDEST_getInstance,
} from './BufferOverflow.mjs';
import { BufferedChannel3lgkhzot5gmk6 as BufferedChannel } from './BufferedChannel.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  _ChannelResult___get_isSuccess__impl__odq1z912b5ogo8613be as _ChannelResult___get_isSuccess__impl__odq1z9,
  _ChannelResult___get_isClosed__impl__mg7kuu1g5u2zmbzbfb4 as _ChannelResult___get_isClosed__impl__mg7kuu,
  Companion_getInstance2d24j5bn8excb as Companion_getInstance,
  _ChannelResult___get_holder__impl__pm9gzw2tjepaj1eg2kq as _ChannelResult___get_holder__impl__pm9gzw,
  ChannelResult__exceptionOrNull_impl_16ei302e9q7b2jc90dz as ChannelResult__exceptionOrNull_impl_16ei30,
  Closed8t4xgopf7j5r as Closed,
} from './Channel.mjs';
import { callUndeliveredElementCatchingException6xwxmojd3rq1 as callUndeliveredElementCatchingException } from '../internal/OnUndeliveredElement.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { addSuppressedu5jwjfvsc039 as addSuppressed } from '../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function trySendImpl($this, element, isSendOp) {
  return $this.m1c_1 === BufferOverflow_DROP_LATEST_getInstance() ? trySendDropLatest($this, element, isSendOp) : $this.a1b(element);
}
function trySendDropLatest($this, element, isSendOp) {
  var result = protoOf(BufferedChannel()).y1a.call($this, element);
  if (_ChannelResult___get_isSuccess__impl__odq1z9(result) || _ChannelResult___get_isClosed__impl__mg7kuu(result))
    return result;
  if (isSendOp) {
    var tmp0_safe_receiver = $this.p18_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp1_safe_receiver;
    }
  }
  return Companion_getInstance().a1a(Unit_instance);
}
var ConflatedBufferedChannelClass;
function ConflatedBufferedChannel() {
  if (ConflatedBufferedChannelClass === VOID) {
    class $ extends BufferedChannel() {
      constructor(capacity, onBufferOverflow, onUndeliveredElement) {
        onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
        super(capacity, onUndeliveredElement);
        this.l1c_1 = capacity;
        this.m1c_1 = onBufferOverflow;
        // Inline function 'kotlin.require' call
        if (!!(this.m1c_1 === BufferOverflow_SUSPEND_getInstance())) {
          var message = 'This implementation does not support suspension for senders, use ' + getKClass(BufferedChannel()).j1() + ' instead';
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(this.l1c_1 >= 1)) {
          var message_0 = 'Buffered channel capacity must be at least 1, but ' + this.l1c_1 + ' was specified';
          throw IllegalArgumentException().n2(toString(message_0));
        }
      }
      s1a() {
        return this.m1c_1.equals(BufferOverflow_DROP_OLDEST_getInstance());
      }
      *x1a(element, $completion) {
        // Inline function 'kotlinx.coroutines.channels.onClosed' call
        var this_0 = trySendImpl(this, element, true);
        var tmp = _ChannelResult___get_holder__impl__pm9gzw(this_0);
        if (tmp instanceof Closed()) {
          ChannelResult__exceptionOrNull_impl_16ei30(this_0);
          var tmp0_safe_receiver = this.p18_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            addSuppressed(tmp1_safe_receiver, this.u19());
            throw tmp1_safe_receiver;
          }
          throw this.u19();
        }
        return Unit_instance;
      }
      y1a(element) {
        return trySendImpl(this, element, false);
      }
    }
    initMetadataForClass($, 'ConflatedBufferedChannel', VOID, VOID, VOID, [1, 0]);
    ConflatedBufferedChannelClass = $;
  }
  return ConflatedBufferedChannelClass;
}
//region block: exports
export {
  ConflatedBufferedChannel as ConflatedBufferedChannel16nes42ao4b78,
};
//endregion

//# sourceMappingURL=ConflatedBufferedChannel.mjs.map
